import Vue from "vue";
import Vuex from "vuex";
import layout from "./layout";
import basic from "./basic";
import helpCenter from "./help-center";
import search from "./search";
import listFilter from "./list-filter";
import industryZone from "./industry-zone";
import subscribe from "./subscribe";
import resetPassword from "./reset-password";
import createPersistedState from "vuex-persistedstate";
import { libSubscribeNewbieGuide, libDialogMoreContacts, libDialogVirtualNumber } from "qlmbidding2_pc_lib/modules";
import biddingInfo from "./bidding-info";
import constrProject from "./constr-project";
import examineProject from "./examine-project";
import enterpriseMonitoring from "./enterprise-monitoring";
import purchaseIntention from "./purchase-intention";
Vue.use(Vuex);
//持久化存储搜索条件
const searchState = createPersistedState({
  storage: window.sessionStorage,
  paths: ["search"],
});
const listFilterState = createPersistedState({
  storage: window.localStorage,
  paths: ["listFilter"],
});
export default new Vuex.Store({
  modules: {
    layout,
    basic,
    helpCenter,
    search,
    industryZone,
    listFilter,
    subscribe,
    resetPassword,
    libSubscribeNewbieGuide,
    purchaseIntention,
    biddingInfo,
    constrProject,
    examineProject,
    libDialogMoreContacts,
    libDialogVirtualNumber,
    enterpriseMonitoring,
  },
  plugins: [searchState, listFilterState],
});
